export default __webpack_public_path__ + "img/gfx_industry_perks-aca96edad7ffbb36ace0e09518460c9a.png";